import 'select2';

const initBlogArticles = (section) => {
  if (section.dataset.blogArticlesReady === 'true') return;

  const form = section.querySelector('[data-blog-filters]');
  const grid = section.querySelector('[data-blog-grid]');
  const status = section.querySelector('[data-blog-status]');
  const empty = section.querySelector('[data-blog-empty]');
  const loadMore = section.querySelector('[data-blog-load-more]');
  const loadMoreWrap = section.querySelector('[data-blog-load-more-wrap]');
  const clearFilters = section.querySelector('[data-blog-clear]');
  const modes = Array.from(section.querySelectorAll('[data-blog-mode]'));
  const selects = Array.from(form?.querySelectorAll('select') || []);
  if (!form || !grid || !status || !empty || !loadMore) return;

  let offset = Number.parseInt(section.dataset.offset, 10) || 0;
  let controller = null;
  let requestSequence = 0;
  let mode = 'newest';
  const state = { category: '', tag: '', sort: 'default' };
  const url = new URL(window.location.href);
  const urlKeys = {
    category: 'blog_category',
    tag: 'blog_tag',
    sort: 'blog_sort',
    mode: 'blog_mode',
  };

  Object.keys(state).forEach((name) => {
    const value = url.searchParams.get(urlKeys[name]);
    if (value) state[name] = value;
  });
  mode = url.searchParams.get(urlKeys.mode) || mode;

  const initSelects = () => {
    selects.forEach((select) => {
      const value = state[select.name];
      if (value) select.value = value;
      if ($(select).hasClass('select2-hidden-accessible')) return;

      $(select).select2({
        allowClear: false,
        dropdownAutoWidth: false,
        dropdownCssClass: 'blog-articles__select-dropdown',
        dropdownParent: $(select).closest('label'),
        minimumResultsForSearch: select.name === 'category' ? 7 : Infinity,
        placeholder: select.options[0]?.textContent || '',
        width: 'auto',
      });
    });
  };

  const setMode = (nextMode) => {
    mode = ['newest', 'popular', 'featured'].includes(nextMode)
      ? nextMode
      : 'newest';
    modes.forEach((button) => {
      const active = button.dataset.blogMode === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const syncUrl = () => {
    const nextUrl = new URL(window.location.href);
    Object.entries(state).forEach(([name, value]) => {
      if (value && !(name === 'sort' && value === 'default')) {
        nextUrl.searchParams.set(urlKeys[name], value);
      } else {
        nextUrl.searchParams.delete(urlKeys[name]);
      }
    });
    if (mode !== 'newest') nextUrl.searchParams.set(urlKeys.mode, mode);
    else nextUrl.searchParams.delete(urlKeys.mode);
    window.history.replaceState({}, '', nextUrl);
  };

  const syncClearButton = () => {
    if (clearFilters) clearFilters.hidden = !(state.category || state.tag);
  };

  const setLoading = (isLoading) => {
    section.classList.toggle('is-loading', isLoading);
    loadMore.disabled = isLoading;
    if (isLoading) loadMore.setAttribute('aria-busy', 'true');
    else loadMore.removeAttribute('aria-busy');
  };

  const request = async (append = false) => {
    controller?.abort();
    controller = new AbortController();
    const requestId = ++requestSequence;
    const params = new URLSearchParams();

    if (state.category) params.set('category', state.category);
    if (state.tag) params.set('tag', state.tag);
    if (state.sort !== 'default') params.set('sort', state.sort);
    params.set('mode', mode);
    params.set('offset', append ? offset : 0);
    if (section.dataset.language)
      params.set('language', section.dataset.language);
    params.set('_request', Date.now());

    setLoading(true);
    status.textContent = append
      ? section.dataset.loadingMore
      : section.dataset.loading;

    try {
      const response = await fetch(`${section.dataset.endpoint}?${params}`, {
        cache: 'no-store',
        signal: controller.signal,
      });
      if (!response.ok) throw new Error('Request failed');
      const result = await response.json();
      if (requestId !== requestSequence) return;

      if (append) grid.insertAdjacentHTML('beforeend', result.html);
      else grid.innerHTML = result.html;
      offset = result.nextOffset;
      empty.hidden = result.total > 0;
      loadMore.hidden = !result.hasMore;
      if (loadMoreWrap) loadMoreWrap.hidden = !result.hasMore;
      status.textContent = result.total
        ? section.dataset.loaded
        : section.dataset.noResults;
      syncUrl();
    } catch (error) {
      if (error.name !== 'AbortError')
        status.textContent = section.dataset.error;
    } finally {
      if (requestId === requestSequence) setLoading(false);
    }
  };

  $(form).on('change', 'select', (event) => {
    state[event.target.name] = event.target.value;
    syncClearButton();
    request(false);
  });
  loadMore.addEventListener('click', () => request(true));
  modes.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.dataset.blogMode === mode) return;
      setMode(button.dataset.blogMode);
      request(false);
    });
  });
  clearFilters?.addEventListener('click', () => {
    ['category', 'tag'].forEach((name) => {
      state[name] = '';
      if (form.elements[name])
        $(form.elements[name]).val('').trigger('change.select2');
    });
    syncClearButton();
    request(false);
  });

  initSelects();
  setMode(mode);
  syncClearButton();
  section.dataset.blogArticlesReady = 'true';

  if (
    [state.category, state.tag].some(Boolean) ||
    state.sort !== 'default' ||
    mode !== 'newest'
  ) {
    request(false);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-blog-articles]').forEach(initBlogArticles);
});
